/**
 *  SCRIPTS USED WHEN VIEWING TOOLKIT
 */

// Helpers
var isMobileLayout = require('./helpers/04_isMobileLayout.js');

/* ALL COMPONENTS */
var mainNavigation = require('./components/global/01_mainNavigation.js');
var Collapser = require('./components/global/02_collapser.js');
var filterMobile = require('./components/global/03_filter.js');
var chooseCard = require('./components/global/04_choose-card.js');
var toggleSelector = require('./components/global/05_toggle.js');
var radioMenu = require('./components/global/06_radio-menu.js');
var modal = require('./components/global/07_modal.js');
var slickSlider = require('./components/global/08_slider.js');
var qtyPlus = require('./components/global/09_qtyplus.js');
var sizeMenu = require('./components/global/10_size-menu.js');
var autoCollapser = require('./components/global/11_auto-collapser.js');
var quickCart = require('./components/global/12_quick-cart.js');
var popover = require('./components/global/12_popover.js');
var imageZoom = require('./components/global/13_zoom.js');
// var brandCarousel = require('./components/global/brandCarousel.js');
// var Counters = require('./components/global/counters.js');
// var Maps = require('./components/global/maps.js');


// Cookie notice
// var handleCookies = require('./helpers/02_handleCookies.js');
// handleCookies();

svg4everybody();

$(function() {
    $('#form-newsletter').parsley();
});

/* LOAD THEM */
mainNavigation();
filterMobile();
isMobileLayout();
Collapser();
chooseCard();
toggleSelector();
radioMenu();
sizeMenu();
slickSlider();
qtyPlus();
modal();
autoCollapser();
quickCart();
popover();
imageZoom();



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/toolkit.js